import { useEffect } from 'react';
import { APP_VERSION_POLL_INTERVAL_MS } from '@/constants/appVersion';
import { fetchAppVersionManifest, getInitialBuildId, notifyAppVersionUpdate } from '@/helpers/appVersion';

export const useAppVersionCheck = (): void => {
  useEffect(() => {
    const initialBuildId = getInitialBuildId();
    let isCancelled = false;

    const checkVersion = async (): Promise<void> => {
      try {
        const manifest = await fetchAppVersionManifest();

        if (isCancelled) {
          return;
        }

        if (manifest.buildId !== initialBuildId) {
          notifyAppVersionUpdate();
        }
      } catch {
        // Ignore transient network errors during version checks.
      }
    };

    void checkVersion();

    const intervalId = window.setInterval(() => {
      void checkVersion();
    }, APP_VERSION_POLL_INTERVAL_MS);

    const handleVisibilityChange = (): void => {
      if (document.visibilityState === 'visible') {
        void checkVersion();
      }
    };

    const handleWindowFocus = (): void => {
      void checkVersion();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleWindowFocus);

    return () => {
      isCancelled = true;
      window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, []);
};
